import { useEffect } from 'react';

/**
 * Hook para sincronizar los valores con las slides del carrusel
 */
export const useCarouselValues = () => {
  useEffect(() => {
    const syncValuesWithCarousel = () => {
      // Observar cambios en las slides del carrusel
      const carouselSlides = document.querySelectorAll('.carousel-slide');
      const valuesSlides = document.querySelectorAll('.values-slide');
      
      if (!carouselSlides.length || !valuesSlides.length) return;

      // Función para activar el slide de valores correspondiente.
      // Módulo por si el carrusel tiene más fotos que pares de valores
      // (ej. 5 fotos de oficina vs 4 pares de valores) — cicla los
      // valores en vez de dejar el overlay vacío en las fotos sobrantes.
      const activateValueSlide = (activeIndex: number) => {
        const targetIndex = activeIndex % valuesSlides.length;
        valuesSlides.forEach((slide, index) => {
          if (index === targetIndex) {
            slide.classList.add('active');
          } else {
            slide.classList.remove('active');
          }
        });
      };

      // Observer para detectar cambios en las slides del carrusel
      const observer = new MutationObserver(() => {
        const activeSlide = document.querySelector('.carousel-slide.active');
        if (activeSlide) {
          const activeIndex = Array.from(carouselSlides).indexOf(activeSlide);
          activateValueSlide(activeIndex);
        }
      });

      // Observar cambios en las clases de las slides
      carouselSlides.forEach(slide => {
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['class']
        });
      });

      // Activar el primer slide al inicio
      const initialActiveSlide = document.querySelector('.carousel-slide.active');
      if (initialActiveSlide) {
        const initialIndex = Array.from(carouselSlides).indexOf(initialActiveSlide);
        activateValueSlide(initialIndex);
      } else {
        // Si no hay slide activo, activar el primero
        activateValueSlide(0);
      }

      // Cleanup
      return () => {
        observer.disconnect();
      };
    };

    // Delay para asegurar que el DOM esté completamente cargado
    const timeoutId = setTimeout(syncValuesWithCarousel, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
};